<template>
    <v-container :class="isMobile? 'pb-0 pt-0':'pt-0'">
        <div id="go_PaymentOptions">
        <v-card>
            <v-card-title primary-title><h2 :style="'color:' + theme.primary.base">Select Payment Method</h2></v-card-title>
                <v-list class="pl-2 pr-2">
                    <template v-for="(pmOpt,index) in paymentOptions">
                        <v-divider v-if="index==0 && paymentOptions.length>1" :key="`dividerU-${index}`"></v-divider>  
                        <v-list-tile :key="'pmOpt_'+index" @click="setPaymentMethod(index);" 
                            :style="'border:solid 2px '+ (selectedPaymentMethod==pmOpt.id? defaultColors.primary:'#fff') + ';'">
                            <v-list-tile-avatar>
                                <v-icon>{{getIcon(pmOpt.paymentCode)}}</v-icon>
                            </v-list-tile-avatar>
                            
                            <v-list-tile-content>
                                <v-list-tile-title>{{pmOpt.paymentCode.replace(/_/g," ")}} <span style="font-size:small;color:orange;float:right;" 
                                    v-if="pmOpt.processingFee>0">( PROCESSING FEE {{getSellingCurrencyCode(pmOpt.currency)}} {{helper.numberFormat.formatPrice(getConvertedAmount(pmOpt.processingFee))}} )</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            
                        </v-list-tile>  
                        <v-divider v-if="index + 1 < paymentOptions.length" :key="`dividerL-${index}`"></v-divider>  
                    </template>                        
                </v-list>
        </v-card>
        </div>
    </v-container>   




</template>

<script>
//import BillPaymentBox from './BillPaymentBox';
import Theme from '../../theme'
import Helper from '../helper';
import Service from '../../services/passernger.service';

export default {
    props:['sellingCurrency'],
    components:{

    },
    created(){
      //setTimeout(() => {
        // alert(JSON.stringify(this.sellingCurrency))
        this.getPaymentOptions()
      //}, 200);
    },
    data(){
        return {
            paymentMethod:"",
            selectedPaymentMethod:-1,
            defaultColors:{
                primary:Theme.primary.base,
                secondary:Theme.secondary
            },
            theme:Theme,
            helper:Helper,
            paymentOptions:[],
            emitters:{
                emSelectedPaymentType:"emSelectedPaymentType",
            }           
        }
    },
    methods:{
        emitSelectedPaymentType(){
            let tProcessingFee = this.paymentOptions[this.selectedPaymentMethod].processingFee;
            if (tProcessingFee==null) tProcessingFee = 0;

            let paymentType = {
                paymentType:this.paymentOptions[this.selectedPaymentMethod].paymentCode,
                merchantType: this.paymentOptions[this.selectedPaymentMethod].merchantCode,
                processingFee: tProcessingFee,
            }
            this.$emit(this.emitters.emSelectedPaymentType,paymentType);
            //alert("Payment type selected.");
        },
        setPaymentMethod(option){
            //alert(option);
            this.selectedPaymentMethod = option;
            this.emitSelectedPaymentType();
        },
        getPaymentOptions(){
            Service.getPaymentOptions().then(rslt=>{
                this.paymentOptions = [];
                if (rslt.data!=null&&rslt.data.length>0){
                    rslt.data.forEach(pmOpt => {
                        this.paymentOptions.push({
                            id:rslt.data.indexOf(pmOpt),
                            merchantCode: pmOpt.MerchantCode,
                            paymentCode: pmOpt.PaymentCode,
                            farePrice:pmOpt.FarePrice,
                            processingFee: pmOpt.Free,
                            grandTotal: pmOpt.GrandTotal,
                            currency:pmOpt.Currency,
                        });
                    });
                }
            });
        },
        getIcon(paymentCode){
            let mappings = [
                ["BANK TRANSFER","account_balance"],
                ["CREDIT CARD","credit_card"],
                ["GB_QR_PAYMENT","dashboard"],
                ["SCB_QR_PAYMENT","dashboard"],
            ];
            let icon = "";
            mappings.forEach(m=>{
                if(m[0]==paymentCode){
                    icon = m[1];
                }
            });
            return icon;
        },
        getSellingCurrencyCode (original) {
          let code = this.sellingCurrency.code !=''? this.sellingCurrency.code:original
          return code
        },
        getConvertedAmount(amount){
          let amnt = this.helper.sellingCurrency.convertByFxRate(this.sellingCurrency.fxRate,amount)
          return amnt
        }
    },
    computed:{
      isMobile(){
          return Helper.display.isMobile(this.$vuetify.breakpoint.name);
      }  
    }
}
</script>

<style>
#go_PaymentOptions > div > div.v-list.v-list > div {
    margin: 5px;
    border-radius: 4px;
    cursor: pointer;
  }
#go_PaymentOptions > div > div.v-list.v-list > div:hover {
    background: rgb(253, 253, 218);
  }
#go_PaymentOptions > div > div.v-list.v-list > div:active {
    background: rgb(204, 243, 253);
  }

</style>